export default {
  pageTitle: 'Fabrikasi Radiant Tube',
  metaDescription: 'TEF memfabrikasi radiant tube tipe-U dan heater tube berbahan alloy nikel tinggi untuk aplikasi furnace dan pemanasan di industri proses.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Peralatan Lainnya',
  },
  fabricationOf: 'Fabrikasi',
  productName: 'Radiant Tube',
  description: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Radiant Tube dengan berbagai jenis material, tipe, dan spesifikasi.',
};
